import Backbone from "backbone";
import Backdraft from "backdraft-app/src/backdraft";
import { classify } from "shared/formatters/strings";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("ExpressionTerminal", {
    /* expects data in the following format

     {
       terminal: "duration",
       relop: ">",
       value: 150
     }

     Can have optional fields specific to node types, e.g.

     {
       terminal: "pool_param",
       relop: "contains",
       value: "Search",

       pool_param_name: "utm_source"
     }

     */

    set: function(key, value, options) {
      var attributes;
      if (typeof key === 'object') {
        attributes = key;
        options = value;
      } else {
        (attributes = {})[key] = value;
      }

      return Backbone.Model.prototype.set.call(this, this.beforeSet(attributes), options);
    },

    beforeSet: function(attributes) {
      return attributes;
    },

    type: function() {
      return classify(this.get('terminal'));
    },

    text: function() {
      return this.get('terminal');
    },

    errorMessages: function() {
      if (!this.isValid()) {
        return "Expression syntax error: " + this.validate().join(", ");
      }
    },

    isConjunctionTerminal: function() {
      return false;
    },

    shouldDisplayValue: function() {
      return true;
    },

    isNotTerminal: function() {
      return false;
    }
  });
});
